import type { FC } from 'react'

import type { BrandKey } from '@jotta/config/brand'
import { hasAccessibilityStatement } from '@jotta/config/hasAccessibilityStatement'
import type { Locale } from '@jotta/i18n/locale'

import { ProseContainer } from '../components/ProseContainer'

import { AccessibilityEN } from './AccessibilityEN'
import { AccessibilityNB } from './AccessibilityNB'
import { AccessibilitySV } from './AccessibilitySV'

function LocaleSwitch({ locale }: { locale: Locale }) {
  switch (locale) {
    case 'nb':
      return <AccessibilityNB />
    case 'sv':
      return <AccessibilitySV />
    default:
      return <AccessibilityEN />
  }
}

export function AccessibilitySwitch({
  brand,
  locale,
  Fallback,
}: {
  brand: BrandKey
  locale: Locale
  Fallback?: FC
}) {
  return hasAccessibilityStatement(brand) ? (
    <ProseContainer>
      <LocaleSwitch locale={locale} />
    </ProseContainer>
  ) : Fallback ? (
    <Fallback />
  ) : undefined
}
